'use client';

import { Link } from '@/i18n/navigation';
import { useSearchParams } from 'next/navigation';

type Props = { totalPages: number };

function NextLink(props: Props) {
  const { totalPages } = props;
  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams);
  const page = searchParams.get('page') ?? '1';
  const nextPage = parseInt(page, 10) + 1;
  const disabled = nextPage > totalPages;

  params.set('page', nextPage.toString());

  if (disabled) {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <a role='link' className='pagination__link' aria-disabled>
        &raquo;
      </a>
    );
  }

  return (
    <Link
      href={`?${params.toString()}`}
      aria-label={`Nächste Seite, Seite ${nextPage}`}
      className='pagination__link'
    >
      &raquo;
    </Link>
  );
}

export default NextLink;
